import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {
  App, Login, Home,Register,Offerings,Resources,News,Videos,SalesKits,Events,
  BMOs,ResourceBMOs,Partners,Offering,Resource,New,Video,SalesKit,Event,
  BMO,ResourceBMO,Partner,FAQ,MAP,ContactUs,Search,ErrorPage
} from '../_Views/Containers';
import withTracker from '../common/analytics';



const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path='/login'  component={withTracker(Login, {} )} />
      <Route exact path='/login/:userid/:code' component={withTracker(Login, {} )} />
      <Route exact path='/register' component={withTracker(Register, {} )} />

      <Route exact path='/news' component={withTracker(News,{})} />
      <Route exact path='/news/:slug' component={withTracker(New,{})} />

      <Route exact path='/contact' component={withTracker(ContactUs,{})} />
      
      <App>
        <Switch>
          <Route exact path='/'  component={withTracker(Home, {} )} />
          <Route exact path='/offerings' component={withTracker(Offerings, {} )}  />
          <Route exact path='/offerings/:slug'  component={withTracker(Offering, {} )} />

          {/*
          <Route exact path='/resources' component={withTracker(Resources,{})} />
          <Route exact path='/resources/:slug' component={withTracker(Resource,{})} />
          */}
          


          <Route exact path='/videos' component={withTracker(Videos,{})} />
          <Route exact path='/videos/:slug' component={withTracker(Video,{})} />

          <Route exact path='/products' component={withTracker(SalesKits,{})} />
          <Route exact path='/products/:slug' component={withTracker(SalesKit,{})} />

          <Route exact path='/operators' component={withTracker(BMOs,{})} />   {/*added for operators in Home page*/}
          <Route exact path='/operators/:id' component={withTracker(BMO,{})} /> {/*added for operators in Home page*/}

         <Route exact path='/resources' component={withTracker(ResourceBMOs,{})} /> {/*azar*/}
         <Route exact path='/resources/:id' component={withTracker(ResourceBMO,{})} /> {/*azar*/}

          {/*<Route exact path='/news' component={withTracker(Events,{})} />*/}   {/*Changed from events to news*/}
          {/*<Route exact path='/news/:id' component={withTracker(Event,{})} />*/} {/*Comments: 5G Initial menu name Changes, Modified By: <Asar>, Date Modified: <2020-02-06>*/} {/*Changed from events to news*/}
          <Route exact path='/partners' component={withTracker(Partners,{})} />
          <Route exact path='/partners/:id' component={withTracker(Partner,{})} />
          <Route exact path='/faq' component={withTracker(FAQ,{})} />
          <Route exact path='/map' component={withTracker(MAP,{})} /> {/*Comments: 5G Initial Code Changes, Modified By: <Asar>, Date Modified: <2020-01-22>*/}
         
          <Route exact path='/search' component={withTracker(News,{})} />   {/* updated as Offerings instead of Search*/}
          <Route component={withTracker(ErrorPage,{})} />
         
        </Switch>
      </App>
    </Switch>
  </BrowserRouter>
)

export default Routes;